// extracted by mini-css-extract-plugin
module.exports = {"productTactics":"ProductTactics_productTactics__s1946","productSlider":"ProductTactics_productSlider__li9ZJ","slider":"ProductTactics_slider__opwPj"};